
import { Button, Tooltip, useColorModeValue } from "@chakra-ui/react";
import { SettingsIcon } from "components/Icons/Icons";
import PropTypes from "prop-types";
import React from "react";

export default function FixedPlugin(props) {
  const { secondary, onChange, onSwitch, fixed, ...rest } = props;
  let navbarIcon = "white";
  let bgButton = "brand.200";

  const settingsRef = React.useRef();
  return (
    <>
      <Tooltip hasArrow label='Menu Setting' bg='gray.300' color='black'>
        <Button
          h='52px'
          w='52px'
          onClick={props.onOpen}
          bg={bgButton}
          position='fixed'
          variant='no-hover'
          left={document.documentElement.dir === "rtl" ? "35px" : ""}
          right={document.documentElement.dir === "rtl" ? "" : "35px"}
          bottom='30px'
          borderRadius='50px'
          boxShadow='0 2px 12px 0 rgb(0 0 0 / 16%)'>
          <SettingsIcon
            cursor='pointer'
            ref={settingsRef}
            color={navbarIcon}
            w='20px'
            h='20px'
          />
        </Button>
      </Tooltip>

    </>
  );
}

FixedPlugin.propTypes = {
  fixed: PropTypes.bool,
  onChange: PropTypes.func,
  onSwitch: PropTypes.func,
};
